export const SET_LIMIT_PREFIX = '[';
export const SET_LIMIT_POSTFIX = '] Loaded limit';

export const setLimitAction = (entity = 'generic', payload) => ({
    type: SET_LIMIT_PREFIX + entity + SET_LIMIT_POSTFIX,
    payload
});
